import {SETTINGS_PERIOD, SETTINGS_WORKPLACES, SETTINGS_FILTERS} from './types';
import PERIODS from '../../constants/periods';
import WORKPLACES from '../../constants/workplaces';
import INTERRUPTING_DISFUNCTIONS from '../../constants/interruptingDisfunctions';
import NOT_INTERRUPTING_DISFUNCTIONS from '../../constants/notInterruptingDisfunctions';
import PRODUCTS from '../../constants/products';
import PRODUCTSTATES from '../../constants/productstates';
import SHIFTS from '../../constants/shifts';
import {FILTER_CUSTOM} from '../../constants/filters';
import {format} from 'date-fns';

const extractSetting = (settings, type) => {
  switch (type) {
    case SETTINGS_PERIOD:
      return settings[type].type === FILTER_CUSTOM
        ? `${format(settings[type].range.start, 'DD.MMM YYYY')} - ${format(settings[type].range.end, 'DD.MMM YYYY')}`
        : PERIODS.find((t) => t.key === settings[type].type).label;
    case SETTINGS_WORKPLACES:
      return WORKPLACES.find((t) => t.key === settings[type].type).label;
    case SETTINGS_FILTERS:
      let t = '';
      if (settings.productStates) t = t + PRODUCTSTATES.find((t) => t.key === settings.productStates.type).label + ' ';
      if (settings.notInterruptingDisfunctions)
        t =
          t +
          NOT_INTERRUPTING_DISFUNCTIONS.find((t) => t.key === settings.notInterruptingDisfunctions.type).label +
          ' ';
      if (settings.interruptingDisfunctions)
        t = t + INTERRUPTING_DISFUNCTIONS.find((t) => t.key === settings.interruptingDisfunctions.type).label + ' ';
      if (settings.products) t = t + PRODUCTS.find((t) => t.key === settings.products.type).label + ' ';
      if (settings.shifts) t = t + SHIFTS.find((t) => t.key === settings.shifts.type).label + ' ';
      return t;
    default:
      return;
  }
};

export default extractSetting;
